export default "__VITE_ASSET__BhxYipxA__"